import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { cx } from '../lib/cx';

type Variant = 'primary' | 'secondary' | 'quiet';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  /** Full width below the small breakpoint, where thumbs need the whole row. */
  block?: boolean;
  children: ReactNode;
}

/* Pill buttons in the accent green, matching etrenziksmarthome.com. Theirs sit
   at about 40px tall; ours are 48px because this audience is older and on
   phones (CLAUDE.md 2). */
const base =
  'inline-flex min-h-tap items-center justify-center gap-2 rounded-full border px-6 ' +
  'text-[0.95rem] font-semibold transition-colors duration-150 ' +
  'disabled:cursor-not-allowed disabled:opacity-45';

const variants: Record<Variant, string> = {
  primary:
    'border-green-600 bg-green-600 text-white hover:border-green-700 hover:bg-green-700',
  secondary: 'border-grey-300 bg-white text-ink hover:bg-grey-050',
  quiet:
    'border-transparent bg-transparent px-2 text-green-700 underline ' +
    'decoration-1 underline-offset-4 hover:decoration-2',
};

export default function Button({
  variant = 'primary',
  block = false,
  className,
  type = 'button',
  children,
  ...rest
}: ButtonProps) {
  return (
    <button
      type={type}
      className={cx(base, variants[variant], block && 'w-full sm:w-auto', className)}
      {...rest}
    >
      {children}
    </button>
  );
}
